import { CompanyTypeEnum } from "../unit-code";

export class CompanyReq{
    company:any

    constructor(company:any){
        this.company = company
    }
}